import React from "react";
import "./index.scss"
import topbarLogo from "../../assets/logo-backblue.png";
import Option from "../../assets/option.png";
import animateCss from "../../utils";
import { Link } from "react-router-dom"
import $ from "jquery";
import ExtMenu from '../../components/ExtMenu';

class TopBar extends React.Component {

    state = {
        isExt: false,
    }

    ref = React.createRef()
    extRef = React.createRef()

    close() {
        this.extRef.current.classList.remove("animate__slideInDown")
        animateCss(this.extRef.current, "slideOutUp")
        .then(() => {
            this.setState({isExt: false})
        })
    }

    componentDidMount() {
        window.addEventListener("wheel", (e) => {
            if (this.state.isExt) this.close();
            const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
            // if (e.deltaY > 0 && scrollTop > 490 && this.props.isShow) {
            //     this.props.setShow({ isShow: false })
            //     animateCss(this.ref.current, "slideOutUp")
            // } else if (e.deltaY < 0 && !this.props.isShow) {
            //     this.props.setShow({ isShow: true })
            //     this.ref.current.classList = ["hb-top-bar visible"]
            //     animateCss(this.ref.current, "slideInDown")
            // }
            // if (e.deltaY < 0 && scrollTop < 490) {
            //     this.ref.current.classList = ["hb-top-bar"]
            // }
            if (location.pathname == "/news-detail") return;
            if (e.deltaY > 0 && this.props.isShow) {
                this.props.setShow({ isShow: false })
                animateCss(this.ref.current, "slideOutUp")
            } else if (e.deltaY < 0 && !this.props.isShow) {
                this.props.setShow({ isShow: true })
                this.ref.current.classList = ["hb-top-bar visible"]
                animateCss(this.ref.current, "slideInDown")
            }
            if (e.deltaY < 0 && scrollTop < 490) {
                this.ref.current.classList = ["hb-top-bar"]
            }
        })
        
        this.props.setShow({top: this.positions[location.pathname.split("/").pop()]})
    }

    positions = {
        "": "15rem",
        "project-pipe": "8.5rem",
        "about-us": "10rem",
        "user-case": "8.5rem",
        "latest-news": "8.5rem",
        "news-detail": "-20rem"
    }

    setPathname(e) {
        const path = $(e.target)
        const lastNode = path[0].href.split("/").pop()
        if (!lastNode){
            this.props.setShow({top: "15rem"})
        } else {
            this.props.setShow({top: this.positions[lastNode]})
        }
    }

    openExt() {
        if (location.pathname == "/news-detail") {
            return;
        }
        this.ref.current.classList = ["hb-top-bar visible"]
        this.setState({isExt: true})
    }

    render() {
        return <div className={`hb-top-bar`} ref={this.ref}>
            <img src={topbarLogo} className="top-bar-logo"/>
            <ul className="tool-menu" onClick={(e)=>this.setPathname(e)}>
                <li className="tool-menu-item" onClick={() => window.scrollTo(0, 0)}>
                    <Link to="/">首页</Link>
                    <div className="top-underline"></div>
                </li>
                <li className="tool-menu-item series-product" onClick={() => window.scrollTo(0, 0)}>
                    <Link to={{ pathname: "/project-pipe", state: { activeSlide: 1 }}} onMouseEnter={()=>this.openExt()}>系列产品</Link>
                    <div className="top-underline"></div>
                </li>
                <li className="tool-menu-item" onClick={() => window.scrollTo(0, 0)}>
                    <Link to="/user-case">用户案例</Link>
                    <div className="top-underline"></div>
                </li>
                <li className="tool-menu-item" onClick={() => window.scrollTo(0, 0)}>
                    <Link to="/latest-news">新闻动态</Link>
                    <div className="top-underline"></div>
                </li>
                <li className="tool-menu-item" onClick={() => window.scrollTo(0, 0)}>
                    <Link to="/about-us">关于我们</Link>
                    <div className="top-underline"></div>
                </li>
            </ul>
            <div className="ext-container" style={{ height: this.state.isExt ? "6.4667rem" : 0 }}>
                {this.state.isExt ? <ExtMenu extRef={this.extRef} topBarRef={this.ref} closeExt={(isExt)=>this.setState(isExt)}/> : null}
            </div>
        </div>
    }
}

export default TopBar;